/* eslint-disable */
import $ from 'jquery';
import registerJQueryPlugin from '../../lib/register-jquery-plugin';
import mergeOptions from '../../lib/merge-options';

export const PLUGIN_NAME = 'modelSwitch';

const DEFAULTS = {
  model: -1,
  modelHeight: '',
  modelSize: '',
};

const $sizeEl = $('.multiple-models__size');
const $heightEl = $('.multiple-models__height');

const switchModel = ($el, opts) => {
  const { code, modelHeight, modelSize, modelNum } = $el.data();
  $sizeEl.text(modelSize);
  $heightEl.text(modelHeight);

  window.insertStylisticsImagesByAjax(code, modelNum);
};

const addEventListeners = ($el, opts) => {
  $el.on('click', () => switchModel($el, opts));
};

export default function modelSwitch(el, options) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);

  addEventListeners($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, modelSwitch);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/abtest/model-switch.js